import React, {useState, useEffect} from 'react'
import Plot from 'react-plotly.js'
import {Select} from 'antd'
import axios from 'axios'
import {Card, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import { useSelectedWeek } from '../../../../../contexts/SelectedWeekContext';

const {Option} = Select

interface DataItem {
  week: string
  disease: string
  count: number
}

const NumberGoogleSearch = () => {
const { selectedWeek } = useSelectedWeek('2023-W40');
const [data, setData] = useState<DataItem[]>([])
const [SymptomClass, setSymptomClass] = useState([])
const [selectedSymptomClass, setSelectedSymptomClass] = useState<string[]>([
  "sum"
  ])
  const [missingData, setMissingData] = useState<DataItem[]>([])
  function addMissingWeek(data: DataItem[]): DataItem[] {
    const startWeek = '2023-W34' // First week in the data
    const endWeek = '2024-W18' // Last week in the data
    const existingWeeks = new Set(data.map((item) => item.week)) // Set to store existing weeks
    const missingData: DataItem[] = []
    const newData: DataItem[] = []

    let currentWeek = startWeek

    while (currentWeek !== endWeek) {
      // Move to the next week
      const [year, weekNum] = currentWeek.split('-W')
      const weekNumber = parseInt(weekNum)
      if (weekNumber < 52) {
        currentWeek = `${year}-W${(weekNumber + 1).toString()}`
      } else {
        currentWeek = `${parseInt(year) + 1}-W1`
      }
      if (!existingWeeks.has(currentWeek)) {
        newData.push({
          week: currentWeek,
          disease: '',
          count: 0,
        })
        missingData.push({
          week: currentWeek,
          disease: '',
          count: 0,
        })
      }
    }

    // Find the index to insert the new week
    let insertionIndex = 0
    for (let i = 0; i < data.length; i++) {
      if (data[i].week <= '2023-W52') {
        insertionIndex = i + 1
      } else {
        break
      }
    }
    setMissingData(missingData)
    // Merge existing data with the newly added missing weeks
    const mergedData = [
      ...data.slice(0, insertionIndex),
      ...newData,
      ...data.slice(insertionIndex),
    ].sort((a, b) => {
      const aYear = parseInt(a.week.substring(0, 4), 10)
      const aWeek = parseInt(a.week.substring(a.week.indexOf('-W') + 2), 10)
      const bYear = parseInt(b.week.substring(0, 4), 10)
      const bWeek = parseInt(b.week.substring(b.week.indexOf('-W') + 2), 10)
      if (aYear !== bYear) {
        return aYear - bYear
      } else {
        return aWeek - bWeek
      }
    })

    return mergedData
  }
  const API_URL = process.env.REACT_APP_API_URL
  const fetchData = async (
    geo = selectedSymptomClass
    ) => {
    try {
      const response = await axios.get(
        API_URL + `/googleTrendsRespiratorySyndroms/numberGoogleSearches?disease=${geo}`
      )
      setData(addMissingWeek(response.data))
    } catch (error) {
      console.error('Error fetching data:', error)
      // Handle error or set a default value for data
      setData([])
    }
  }
  useEffect(() => {
    const listSymptomClass = async () => {
      try {
        const response = await axios.get(
          API_URL + '/googleTrendsRespiratorySyndroms/listDisease'
        )
        const data = response.data
        setSymptomClass(data)
      } catch (error) {
        console.error('Error fetching data:', error)
        return null
      }
    }
    listSymptomClass()
    fetchData()
  }, [selectedSymptomClass,selectedWeek])
  const trace3 = {
    x: data.map((entry) => entry.week),
    y: data.map((entry) => entry.count),
    type: 'scatter',
    mode: 'lines',
    yaxis: 'y',
    marker: {color: '#203879'},
    name: 'Number of Google searches reporting respiratory symptoms',
  }
  const missdata = {
    x: missingData.map((entry) => entry.week),
    y: missingData.map((entry) => entry.count),
    type: 'scatter',
    mode: 'markers',
    yaxis: 'y',
    name: 'Missing Data',
    marker: {color: '#000000'},
  }
  

  const plotData = [trace3,missdata]
  const selectedYear = parseInt(selectedWeek.slice(0, 4));
  const selectedWeekNumber = parseInt(selectedWeek.slice(6));
  const startDate = 2023;
  const startWeek = 35;
  const endYear = 2024;
  const endWeek = 18;
  const showArrow = (selectedYear > startDate || (selectedYear === startDate && selectedWeekNumber >= startWeek)) &&
                    (selectedYear < endYear || (selectedYear === endYear && selectedWeekNumber <= endWeek));
  const layout = {
    title: "Number of Google searches reporting respiratory symptoms",
    barmode: 'stack',
    bargap: 0.2, // Adjust the gap between bars
    bargroupgap: 0.1, // Adjust the gap between bar groups
    autosize: true,

    annotations: [
      {
        xref: 'paper',
        yref: 'paper',
        x: -0.035,
        xanchor: 'right',
        y: 0.5,
        yanchor: 'bottom',
        text: '#',
        font: {
          size: 25,

          color: '#b0dff9',
        },
        showarrow: false,
      },
      {
        x: selectedWeek,
        y: 0,
        xref: 'x',
        yref: 'y',
        text: showArrow ? 'Selected Week' : '',
        font: {
          family: 'Courier New, monospace',
          size: 16,
          color: '#CC1B1B',
        },
        arrowcolor: '#CC1B1B',
        showarrow: showArrow,
        arrowhead: 7,
        ax: 0,
        ay: -180,
      },
    ],

    xaxis: {
      title: 'Weeks',
      autorange: true,
      type: 'category',
      tickangle: -45,
    },
    yaxis: {
      autorange: true,
    },
    legend: {
      x: 0,
      y: -0.5, // Adjust the value to position the legend as per your requirement
      orientation: 'h', // 'h' for horizontal, 'v' for vertical
    },
  }

  function handleDataChangeAge(value): void {
    setSelectedSymptomClass(value)
    fetchData(value)
  }

return (
  <>
    <div className='mx-4'>
      {/* begin::Row  */}
      <div className='row '>
        <Card className='mb-8'>
          <div className='card'>
            <div className='card-body'>
              <h2 className='text-primary bold'>
                {' '}
                Number of Google searches reporting respiratory symptoms
                <OverlayTrigger
                  placement='right'
                  overlay={
                    <Tooltip id='logo-tooltip' style={{width: '300px'}}>
                      <p>
                      Number of Google searches reporting respiratory symptoms
                      </p>
                    </Tooltip>
                  }
                >
                  <img
                    style={{width: '12px', marginLeft: '10px'}}
                    alt='logo'
                    src={toAbsoluteUrl('/media/logos/ii.svg')}
                  />
                </OverlayTrigger>
              </h2>
            </div>
            <Card.Body className='row' style={{marginTop:'-35px'}}>
      <div className='row'>
        <label style={{width: '10%'}} className='col-1 mt-3 text-primary fw-medium fs-5'>
          Symptom :
        </label>
        <div className='col-6'>

        <Select
            variant='borderless'
            className='border border-gray-500 border-3 rounded'
            style={{ width: '71%' }}
            size='large'
            value={selectedSymptomClass}
            onChange={(value) => handleDataChangeAge(value)}
          >
            {[
              "sum", // Add "sum" at the beginning of the array
              ...SymptomClass.filter((category) => category !== "sum"), // Filter out "sum" from the original array
            ].map((category) => {
              let readableAge;
              if (category === "sum") {
                readableAge = "All Symptoms";
              }
              return (
                <Option key={category} value={category}>
                  {readableAge ? readableAge : category}
                </Option>
              );
            })}
          </Select>

          
        </div>
      </div>
      <Plot
        style={{width: '100%', height: '400px'}}
        data={plotData}
        layout={layout}
        config={{
          displaylogo: false,
          responsive: true,
        }}
      />
              <p className='card-text source'>
                <p className='card-text source mt-2'>
                  <i>
                    Source:<a className='fw-bold' href='http://www.fraunhofer.de/en'> Fraunhofer</a> , based on Google searches
                  </i>{' '}
                </p>
              </p>
            </Card.Body>
          </div>
        </Card>
      </div>
    </div>
  </>
)
}

export default NumberGoogleSearch
